import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  statusKey,
  WorkshopJobListStoreService
} from '../workshop-job-list-store.service';
import { WORKSHOP } from '../../../../testIds';
import { startWith, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkshopJobStatusLabelPipe } from '../../../shared/pipes/workshop-job-status-label.pipe';
import { MatOption } from '@angular/material/core';
import { NgFor, AsyncPipe } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { TestIdDirective } from '../../../shared/directives/test-id.directive';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-workshop-list-filter',
    templateUrl: './workshop-list-filter.component.html',
    standalone: true,
    imports: [MatCard, MatCardContent, ReactiveFormsModule, MatFormField, TestIdDirective, MatLabel, MatInput, MatSelect, NgFor, MatOption, AsyncPipe, WorkshopJobStatusLabelPipe]
})
export class WorkshopListFilterComponent {
  testIds = WORKSHOP;
  form = new FormGroup({
    search: new FormControl<string>(''),
    status: new FormControl<statusKey>('in_progress'),
    customer: new FormControl<'external' | 'internal' | 'both'>('both')
  });

  availableStatuses$ = this.workshopJobListStore.availableStatuses$;

  constructor(
    private workshopJobListStore: WorkshopJobListStoreService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.form.valueChanges
      .pipe(
        startWith(this.getDefaultFilter()),
        takeUntil(this.workshopJobListStore.destroy$)
      )
      .subscribe(({ search, status, customer }) => {
        this.router.navigate([], {
          queryParams: { search, status, customer },
          queryParamsHandling: 'merge'
        });
        this.workshopJobListStore.setFilter({ search, status, customer });
      });

    this.activatedRoute.queryParams
      .pipe(
        startWith(this.getDefaultFilter()),
        takeUntil(this.workshopJobListStore.destroy$)
      )
      .subscribe(({ search, status, customer }) => {
        this.form.patchValue(this.getDefaultFilter());
      });
  }

  private getDefaultFilter() {
    const { search, status, customer } =
      this.activatedRoute.snapshot.queryParams;
    return {
      search: search || '',
      status: status || 'in_progress',
      customer: customer || 'both'
    };
  }
}
